import { Link } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";
import { useBranding } from "@/context/BrandingContext";
import { ServerErrorPage } from "@/components/portal/OfflineStep";

export const BrandMark = ({ config, size = "md" }) => {
  const dim = size === "sm" ? "h-9 w-9 text-sm" : "h-11 w-11 text-base";
  if (config?.logo_url) {
    return <img src={config.logo_url} alt={config.org_name} data-testid="brand-logo" className={`${size === "sm" ? "h-9" : "h-11"} w-auto max-w-[160px] object-contain`} />;
  }
  const initials = (config?.org_name || "R").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("");
  return (
    <div data-testid="brand-monogram" className={`${dim} flex items-center justify-center rounded-sm border font-display font-semibold`} style={{ borderColor: "var(--brand)", color: "var(--brand)" }}>
      {initials}
    </div>
  );
};

export const PortalShell = ({ children, offline }) => {
  const { config } = useBranding();
  if (offline ?? config?.system_online === false) return <ServerErrorPage />;
  return (
    <div className="portal-bg relative flex min-h-screen flex-col text-slate-100">
      <div className="grain pointer-events-none absolute inset-0" />
      <header className="relative z-10 border-b border-white/5 bg-black/20 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
          <div className="flex items-center gap-3" data-testid="portal-identity">
            <BrandMark config={config} />
            <div className="leading-tight">
              <p className="font-display text-sm tracking-wide text-slate-50 sm:text-base" data-testid="portal-org-name">{config?.org_name}</p>
              {config?.brand_authorized && config?.partner_brand && (
                <p className="text-[11px] uppercase tracking-[0.2em] text-slate-400" data-testid="portal-partner-brand">Programa Rewards · {config.partner_brand}</p>
              )}
            </div>
          </div>
          <div className="hidden items-center gap-2 text-xs text-slate-400 sm:flex">
            <Lock className="h-3.5 w-3.5" style={{ color: "var(--brand)" }} /> Conexão segura
          </div>
        </div>
      </header>

      <main className="relative z-10 flex flex-1 items-center justify-center px-5 py-12 sm:px-8">{children}</main>

      <footer className="relative z-10 border-t border-white/5 bg-black/30">
        <div className="mx-auto flex max-w-6xl flex-col gap-3 px-5 py-6 text-xs text-slate-400 sm:px-8 md:flex-row md:items-center md:justify-between">
          <p className="flex items-start gap-2" data-testid="portal-security-notice">
            <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0" style={{ color: "var(--brand)" }} />
            Nunca solicitamos senhas bancárias, tokens, códigos de autenticação ou dados de cartão.
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1" data-testid="portal-operator-info">
            <span>Serviço operado por {config?.org_name} · {config?.operator_document}</span>
            <span>{config?.operator_contact}</span>
            <Link to="/privacidade" className="underline-offset-4 hover:underline" style={{ color: "var(--brand)" }} data-testid="footer-privacy-link">Política de privacidade</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
